<template>
    <div class="img-content">
        <template v-for="(item,index) in arr">
            <img :src="changeThumb(item,116,80)" alt="" :style="changePostion(index)"
                 :class="{'no-shadow':arr.length===1}">
        </template>
    </div>
</template>

<script>
export default {
  name: 'imgAndImgs',
  data () {
    return {
      arr: []
    }
  },
  props: {
    src: {
      type: String
    }
  },
  watch: {
    src: {
      handler () {
        if (this.src.indexOf('|') !== -1) {
          this.arr = this.src.split('|').slice(0, 3)
        } else {
          this.arr = [this.src]
        }
      },
      immediate: true
    }
  },
  methods: {
    changeThumb (url, w, h) {
      let ext = url.split('.')
      let ret
      if ((url.indexOf('https://img.imsilkroad.com/a/thumb/') == -1 && url.indexOf('https://img.imsilkroad.com/a/') >= 0)) {
        ret = url.replace('com/a/', 'com/a/thumb/') + '!w' + w + '_h' + h + '.' + ext.pop()
        return ret
      } else if (url.indexOf('https://img.imsilkroad.com/a/thumb/') >= 0) {
        ret = url.replace(/w[0-9]*_/, 'w' + w + '_').replace(/_h[0-9]*/, '_h' + h)
        return ret
      }
      return url
    },
    changePostion (index) {
      if (index) {
        return `top:${index * 3}px;left:${index * 3}px;z-index:${4 - index}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .img-content {
        position: relative;

        img {
            position: absolute;
            object-fit: cover;
            width: 100%;
            height: 100%;
            z-index: 4;
            box-shadow: 1px 1px 8px #939b91;
        }

        .no-shadow {
            box-shadow: none;
        }
    }
</style>
